import type { Command, InvokableAction } from "../models";
import { useJsonReader } from "../../bridge/binary";
import { createProxies } from "./proxies";

export interface JSGlobalCommands {
  globalCommands: Command[];
  toolbarCommands: Command[][];
  topToolbarCommands: Command[][];
  alignDistributeCommands: Command[];
  customShapes: number[];
  customShapeCommand: InvokableAction;

  positionCommands: Command[][];
  imageCommands: Command[][];
  zoomValues: string[][];
}

interface GlobalCommandsExportsMethods {
  GetGlobalCommand: (name: string) => Command | undefined;
  GetGlobalCommands: () => JSGlobalCommands;
  InvokeGlobalCommand: (commandId: number, value: boolean) => void;
  SetPencilShapeColor: (color: string, width: number) => void;
  SetCardColor: (color: string) => void;
  SetSectionColor: (bgColor: string) => void;
  SetCustomShape: (shape: number) => void;
}

export interface GlobalCommandsExports {
  GlobalCommands: GlobalCommandsExportsMethods;
}

const {
  setup,
  getGlobalCommand: getGlobalCommandJson,
  getGlobalCommands: getGlobalCommandsJson,
  invokeGlobalCommand,
  setPencilShapeColor,
  setCardColor,
  setSectionColor,
  setCustomShape,
} = createProxies<GlobalCommandsExportsMethods>([
  "InvokeGlobalCommand",
  "GetGlobalCommand",
  "GetGlobalCommands",
  "SetPencilShapeColor",
  "SetCardColor",
  "SetSectionColor",
  "SetCustomShape",
]);

const getGlobalCommand = useJsonReader(getGlobalCommandJson);
const getGlobalCommands = useJsonReader(getGlobalCommandsJson);

export {
  getGlobalCommand,
  getGlobalCommands,
  invokeGlobalCommand,
  setCardColor,
  setCustomShape,
  setPencilShapeColor,
  setSectionColor,
  setup,
};
